module.exports = __webpack_public_path__ + "img/11.56f705fa.png";